module.exports = __webpack_public_path__ + "img/design.d3a79fdc.png";